import React from 'react';
import moment from 'moment';
import LetterHistory from 'modules/letter-history';
import LetterInformation from 'modules/letter-information';
import { Link, browserHistory } from 'react-router';
import { msg } from 'constants/message';
import { connect } from 'react-redux';
import { Letter, GiaiQuyetDonThu, Danhmuc, Reception } from 'api';
import { Toastr } from 'modules/toastr';
import { ShowIf } from 'components/utils';
import { API_URL } from 'constants/config';
import ButtonGroup from 'modules/handle-letters/button-group';
import { CheckQuyenThaoTacXuLy } from 'modules/login/CheckQuyenThaoTacXuLy';
import { CheckViewPermission } from 'modules/login/CheckPermission';
import { GetTrangThaiDonTheoDonVi } from 'modules/login/GetTrangThaiDonTheoDonVi';
import {KetQuaXuLyDon} from 'modules/giai-quyet-don/subView';
import { CheckQuyenTuXuLy } from 'modules/login/CheckQuyenTuXuLy';
import { ConfirmDialog } from 'modules/dialog';
import { TuGiaiQuyetDon } from 'modules/giai-quyet-don';
import {MasterLayout} from 'layout';
import {Loading} from 'modules/loading';
import classnames from 'classnames';

class HandleLettersOldDetails extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      pageLoading: false,
      // URL param
      typePage: this.props.params.typePage,

      donId: this.props.params.id,
      alias: '',
      params: [],
      data: [],
      processTypeValue: '',

      // Thong tin nguoi dung don
      loaiNguoiDungDon: '',
      dataNguoiDungDon: [],
      dataDoanDiCung: [],

      // Thong tin nguoi duoc uy quyen
      coUyQuyen: false,
      dataNguoiDuocUyQuyen: [],
      listTepUyQuyen: [],
      luatSu: false,
      listTepChungChiHanhNghe: [],

      // ThongTinDonVuViec
      nguonDon: '',
      noiDung: '',
      loaiDon: '',
      loaiDoiTuong: '',
      linhVuc: '',
      linhVucChiTiet: '',
      linhVucChiTietSub: '',
      linhVucChiTietKhac: '',
      // Tai lieu kem theo
      listTaiLieuVanThu: [],
      listTaiLieuBangChung: [],

      // Thong tin co quan dang giai quyet
      coThongTinCoQuanDangGiaiQuyet: false,
      dataCoQuanDangGiaiQuyet: {},

      // Thong tin co quan da giai quyet
      coThongTinCoQuanDaGiaiQuyet: false,
      dataCoQuanDaGiaiQuyet: {},
      lanhDaoDuyet: true,

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      initTaiLieuVanThu: [],

      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],

      loaiTepDinhKem: '',
      loaiQuyTrinh: '',
      noticeMsg: '',
      backConfirm: false,
      hasChange: false
    }
  }

  componentDidMount() {
    this.getDetail(this.props.params.id);
  }

  onClickClose() {
    browserHistory.goBack();
    this.props.dispatch({
      type: 'REFRESH_MENU',
      value: true
    });
  }

  // Gan du lieu xu ly don hoac giai quyet don
  handleDataForm(state) {
    let noticeMsg = state.notice;
    delete state.messege;

    this.setState({
      params: state,
      noticeMsg: noticeMsg,
      hasChange: true
    })
  }

  async getDonInfo(donData) {
    let state = this.state;
    await Reception.actions.getDonCuInfo.request({ id: donData.donCuId }).then(res => {
      if (res.data) {
        donData = {...donData, ...res.data};
      }
      state.data = donData;
      // Thong tin nguoi dung don
      state.loaiNguoiDungDon = donData.loaiNguoiDungDon ? donData.loaiNguoiDungDon : '';
      state.dataNguoiDungDon = donData.listNguoiDungDon ? donData.listNguoiDungDon : [];
      state.dataDoanDiCung = donData.loaiNguoiDungDon === 'DOAN_DONG_NGUOI' ? (donData.listDoanDiCung ? donData.listDoanDiCung : []) : [];
      //
      // Thong tin nguoi duoc uy quyen
      state.coUyQuyen = donData.coUyQuyen;
      state.dataNguoiDuocUyQuyen = donData.coUyQuyen ? donData.nguoiDuocUyQuyen : [];
      //
      state.luatSu = (donData.coUyQuyen && donData.nguoiDuocUyQuyen) ? (donData.nguoiDuocUyQuyen.luatSu) : false;

      // ThongTinDonVuViec
      state.loaiDonGiaTri = donData.loaiDon ? donData.loaiDon : '';
      state.nguonDon = donData.nguonDonText ? donData.nguonDonText : '';
      state.noiDung = donData.noiDung ? donData.noiDung : '';
      state.loaiDon = donData.loaiDonInfo && donData.loaiDonInfo.ten ? donData.loaiDonInfo.ten : '';
      state.loaiDoiTuong = donData.loaiDoiTuongInfo ? donData.loaiDoiTuongInfo : '';
      state.linhVuc = donData.linhVucDonThuDon ? donData.linhVucDonThuDon.ten : '';
      state.linhVucChiTiet = (donData.linhVucDonThuDon && donData.linhVucDonThuChiTietDon) ? donData.linhVucDonThuChiTietDon.ten : '';
      state.linhVucChiTietSub = (donData.linhVucDonThuDon && donData.linhVucDonThuChiTietDon && donData.chiTietLinhVucDonThuChiTietDon) ? donData.chiTietLinhVucDonThuChiTietDon.ten : '';
      state.linhVucChiTietKhac = (donData.linhVucChiTietKhac ? donData.linhVucChiTietKhac : '');
      // Tai lieu kem theo
      // HuongXuLy.jsx
      state.listTaiLieuVanThu = donData.listTaiLieuVanThu ? donData.listTaiLieuVanThu : [];
      state.initTaiLieuVanThu = donData.listTaiLieuVanThu ? donData.listTaiLieuVanThu : [];

      state.listTaiLieuBangChung = [...donData.listTaiLieuBangChung, ...donData.listTaiLieuBangChungLuatSu];

      state.listTaiLieuVanThuBoSungHoSo = donData.listTaiLieuVanThuBoSungHoSo ? donData.listTaiLieuVanThuBoSungHoSo : [];

      state.pageLoading = false;
    }).catch(e => {
      state.pageLoading = false;
    });
    this.setState(state);
  }

  getDetail(inputId) {
    this.setState({pageLoading: true});
    Letter.actions.getDonCuDetail.request({ id: inputId }).then(res => {
      if (res.data) {
        if (CheckViewPermission(res.data)) {
          this.getDonInfo(res.data);
        } else {
          browserHistory.push('/page-403');
        }
      }
    });
  }

  validateSubmitForm() {
    let pass = true;
    if (typeof this.props.validators['formTaoDon'] != 'undefined') {
      this.props.validators['formTaoDon'].map(validator => {
        if (pass) {
          pass = validator.validate();
        }
        else {
          validator.validate();
        }
      });
    }

    return pass;
  }


  handleBack(allowBack) {
    let state = this.state;
    if (allowBack) {
      this.onClickClose();
    } else {
      if (state.hasChange) {
        state.backConfirm = true;
      } else {
        this.onClickClose();
      }
    }
    this.setState(state);
  }

  closeConfirmBack() {
    this.setState({backConfirm: false});
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
      <div>
        <div id="page" className="panel-page document-detail-page">
          <ConfirmDialog open={this.state.backConfirm} onClose={this.closeConfirmBack.bind(this)} onSuccess={this.handleBack.bind(this, true)} title={msg.confirmBack} />
          {
            this.state.pageLoading && <Loading/>
          }
          <div className={classnames('center', {'hidden': this.state.pageLoading})}>
            <div className="back-foward">
              <Link onClick={this.handleBack.bind(this, false)} title="">Về trang trước</Link>
            </div>
            <div className="heading">
              <h2 className="heading-title icon-detail">Chi tiết đơn/ vụ việc</h2>
            </div>
            <div className="page-wrapper">
              <LetterInformation
                checkXLDC={true}
                parent={this.state}
                donId={this.state.donId}
                typePage={this.state.typePage}
                checkDonCu={true}
              />
            </div>
          </div>
          <div className="center mb30 mt30">
            <ButtonGroup
              pageType="DONCU"
              alias={this.state.alias}
              donId={this.state.donId}
              donInfo={this.state.data}
              onClose={this.handleBack.bind(this, false)}
              params={this.state.params}
              processType={this.state.processTypeValue}
              btnLoading={this.state.btnLoading}
              btnSaveLoading={this.state.btnSaveLoading}
              validateSubmitForm={this.validateSubmitForm.bind(this)}
              bindValidator={this}
              onChange={this.handleDataForm.bind(this)}/>
          </div>
        </div>
      </div>
      </MasterLayout>
    );
  }
}

HandleLettersOldDetails.defaultProps = {
  validators: []
}

export default connect()(HandleLettersOldDetails);



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters-old/detail-handle-letters-old/HandleLettersOldDetails.jsx